// extracted by mini-css-extract-plugin
export default {"offcanvasOverlay":"Offcanvar_offcanvasOverlay__rpXPc","open":"Offcanvar_open__-ujFz","offcanvas":"Offcanvar_offcanvas__I3pbh","closeButton":"Offcanvar_closeButton__DC3cD"};